import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Link from "../Link";
import Button from "../Button";
import { DefaultContainer } from "./Theme";
import { fetchJson, post } from "../../lib/Fetching";
import _ from "underscore";

const Container = styled(DefaultContainer)`
  margin-bottom: 4px;
  border-radius: 0px;
  padding: 10px;
  width: 100%;
`;

function capitalize(str) {
  str = str.split(" ");
  for (var i = 0, x = str.length; i < x; i++) {
    str[i] = str[i][0].toUpperCase() + str[i].substr(1).toLowerCase();
  }
  return str.join(" ");
}

export default function AddProducts({ companyId, onAdded }) {
  const [showForm, setShowForm] = useState(false);
  const [companyBranches, setCompanyBranches] = useState(false);

  const [textArea, setTextArea] = useState("");
  const [restrictedBranchIds, setRestrictedBranchIds] = useState([]);
  const [productNames, setProductNames] = useState([]);

  const loadCompanyBranches = () => {
    fetchJson("/crm_api/company_branches", {
      company_id: companyId
    }).then(companyBranches => {
      setCompanyBranches(companyBranches);
    });
  };

  const parseNames = () => {
    const names = _.uniq(
      textArea
        .split("\n")
        .map(s => s.trim())
        .filter(x => x)
        .map(str => capitalize(str))
    );
    setProductNames(productNames.concat(names));
    setTextArea("");
  };

  const toggleBranch = branchId => {
    if (restrictedBranchIds.includes(branchId)) {
      setRestrictedBranchIds(restrictedBranchIds.filter(id => id !== branchId));
    } else {
      setRestrictedBranchIds(restrictedBranchIds.concat(branchId));
    }
  };

  const removeProductName = removeName => {
    setProductNames(productNames.filter(name => name !== removeName));
  };

  const canCreate = productNames.length > 0 && restrictedBranchIds.length > 0;

  const handleCancel = () => {
    setShowForm(false);
    setProductNames([]);
    setRestrictedBranchIds([]);
  };

  const submit = () => {
    post("/products/products.json", {
      company_id: companyId,
      names: productNames,
      company_branch_ids: restrictedBranchIds
    })
      .then(json => {
        if (json.errors) {
          alert(json.errors);
        } else {
          alert("The product names were added successfully.");
          onAdded();
          handleCancel();
        }
      })
      .catch(error => alert(error));
  };

  useEffect(() => {
    if (showForm) {
      loadCompanyBranches();
    }
  }, [companyId, showForm]);

  if (!showForm) {
    return (
      <Container>
        <Link onClick={() => setShowForm(!showForm)}>Add Products</Link>
      </Container>
    );
  }

  return (
    <Container>
      {companyBranches && (
        <div>
          {productNames.length == 0 && (
            <div>
              <p>Add new product names here. Enter each product name on a different line:</p>
              <textarea
                autoFocus
                className="form-control"
                style={{ height: 100, marginBottom: 10 }}
                value={textArea}
                placeholder="Enter each product name on a new line"
                onChange={e => setTextArea(e.target.value)}
              />
              <Button title="Add" small onClick={parseNames} />
              &nbsp;&nbsp;
              <Button title="Cancel" small onClick={handleCancel} />
            </div>
          )}
          {productNames.length > 0 && (
            <Container style={{ marginBottom: 0 }}>
              <h4 style={{ marginTop: 0 }}>Product Names:</h4>
              <ul style={{ listStyleType: "none", paddingLeft: 0 }}>
                {productNames.map(name => (
                  <li key={name}>
                    <Link>
                      <i className="fa fa-times" onClick={() => removeProductName(name)} />
                    </Link>
                    &nbsp;
                    {name}
                  </li>
                ))}
              </ul>
              <h4>Restrict registration to these branches:</h4>
              <ul style={{ listStyleType: "none", paddingLeft: 0 }}>
                {companyBranches.map(branch => (
                  <li>
                    <input
                      type="checkbox"
                      checked={restrictedBranchIds.includes(branch.id)}
                      onChange={() => toggleBranch(branch.id)}
                    />
                    &nbsp;
                    {branch.name}
                  </li>
                ))}
              </ul>
              <Button title="Create Products" primary onClick={submit} disabled={!canCreate} />
              &nbsp;&nbsp;
              <Button title="Cancel" onClick={handleCancel} />
            </Container>
          )}
        </div>
      )}
    </Container>
  );
}
